import { render, staticRenderFns } from "./WorkOrderSignatures.vue?vue&type=template&id=35c572fe&scoped=true"
import script from "./WorkOrderSignatures.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkOrderSignatures.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkOrderSignatures.vue?vue&type=style&index=0&id=35c572fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c572fe",
  null
  
)

export default component.exports